import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    spinner      : false,
    spinner_text : "잠시만 기다려 주세요."
}

const CommonSlice = createSlice({
    name : 'common_data',
    initialState,
    reducers : {
        reduxOnSpinner : (state, action) => {
            state.spinner_text = action.payload;
            state.spinner = true;
        },
        reduxOffSpinner : (state) => {
            state.spinner = false;
        },
    }
});

export const {
    reduxOnSpinner,
    reduxOffSpinner,
} = CommonSlice.actions;

export default CommonSlice.reducer;